module.exports = "https://images.shiksha.ws/saassets/media/Book_SessionSprite.924e6413.svg";